export default {"src":"/_next/static/media/message-plus-circle.2cfc26c3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};